export default "__VITE_ASSET__37c0a55c__"